class window.RegionEdit
    self = undefined

    constructor: (mapID, regionID, baseURL) ->
        self = this

        @mapID = mapID
        @regionID = regionID
        @baseURL = baseURL

        @initializeTerritories()

    initializeTerritories: () ->
        $('#add-territory-form').submit(() ->
            territory = $(this).find("[name=\"territory\"]").val()

            $.ajax({
                url: self.baseURL + '/territory/add'
                method: 'POST'
                data: {
                    _token: csrftoken
                    territory: territory
                }
                success: (result) ->
                    if (result.success)
                        row = $('<tr>' +
                            '<td>' + territory + '</td>' +
                            '<td class="small center"><a class="territory-delete" data-territory-id="' +
                                result.terr_id + '"><i class="fa fa-close"></i></a></td>' +
                        '</tr>')

                        $('#territory-rows').append(row)
                        row.find('.territory-delete').click(self.territoryDelete)
                    else
                        messageDisplay.error(result.error)
                error: reportAjaxError
            })

            $(this).find("[name=\"territory\"]").val('')

            return false
        )

        $('.territory-delete').click(@territoryDelete)

    territoryDelete: () ->
        terrID = $(this).data('territoryId')
        row = $(this).closest('tr')
        wrap = $(this).parent()
        oldContent = wrap.html()
        wrap.html(ajaxLoader)

        $.ajax({
            url: self.baseURL + '/territory/remove'
            method: 'POST'
            data: {
                _token: csrftoken
                territory: terrID
            }
            success: (result) ->
                if (result.success)
                    row.remove()
                else
                    messageDisplay.error(result.error)
                    wrap.html(oldContent)
            error: reportAjaxError
        })
